import { CopyAll } from "@mui/icons-material";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { Api_Key_Service } from "../../services/api-key/api-key-service";
import { Autocomplete } from "../Autocomplete/Autocomplete";
import New_Item from "../new-item";
import { RUDTable } from "../Table/RUDTable";
import API_Key_Form from "./create-api-keys-form";

const initial_filter = { organization: "" };

export default function Api_Keys_Page() {
    const [filter, set_filter] = useState(initial_filter);
    const [tooltipText, setTooltipText] = useState("Copy to clipboard");
    const [count, setCount] = useState(0);

    async function get_org_api_key(org_code: string) {}

    const handleCopy = (text: any) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text);
            setTooltipText("Copied to clipboard");
            setTimeout(() => {
                setTooltipText("Copy to clipboard");
            }, 1000);
        }
    };

    useEffect(() => {
        if (!filter.organization) return;

        get_org_api_key(filter.organization);
    }, [filter.organization]);

    return (
        <Box>
            <New_Item title="Create API Key">
                <API_Key_Form setCount={setCount} />
            </New_Item>

            <RUDTable
                updatingAgents={[filter.organization, count]}
                filters={
                    <Box minWidth={320} mr={1}>
                        <Autocomplete
                            label="Organization"
                            labelKey="name"
                            api="/organization"
                            setOutput={(org) => {
                                set_filter((f) => ({
                                    ...f,
                                    organization: org?.code || "",
                                }));
                            }}
                        />
                    </Box>
                }
                getter={(page, limit) =>
                    Api_Key_Service.getApiKeys({
                        page,
                        limit,
                        filter: {
                            organization: filter.organization,
                        },
                    })
                }
                editor={(id, updated_keys, row) => {
                    console.log(updated_keys, row);
                    return Api_Key_Service.edit_apiKey(
                        row.key,
                        updated_keys,
                        row.organization.code
                    );
                }}
                deletor={(id: any) => {
                    return Api_Key_Service.deleteApiKey(id[0]);
                }}
                rowsPreprocessor={(row) => ({
                    ...row,
                    deletionId: row?.key,
                    org_name: row?.organization?.name,
                })}
                ops={{
                    read: "",
                    edit: "",
                    delete: "",
                }}
                readables={{
                    name: "Name",
                    org_name: "Organization",
                    apiKey: "Key",
                }}
                customCols={[
                    {
                        header: "apiKey",
                        content: (row) => (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "25ch",
                                }}
                            >
                                <Typography variant="body2">
                                    {row.key}
                                </Typography>
                                <Tooltip title={tooltipText} placement="top">
                                    <IconButton
                                        size="small"
                                        color="secondary"
                                        onClick={() => handleCopy(row.key)}
                                    >
                                        <CopyAll
                                            fontSize="small"
                                            color="primary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        ),
                    },
                ]}
                editables={[
                    {
                        isRequired: true,
                        label: "Name",
                        name: "name",
                        type: "textfield",
                    },
                    {
                        isRequired: true,
                        label: "Api Key",
                        name: "key",
                        type: "textfield",
                    },
                ]}
                storageKey="Api Keys List"
            />
        </Box>
    );
}
